// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.l-hamburger').length > 0) {
		$('.l-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is-open');
				nav.removeClass('is-close');
			} else {
				nav.removeClass('is-open');
				nav.addClass('is-close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.l-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is-open');
			nav.addClass('is-close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.l-hamburger:visible').length > 0) {
				$('.l-hamburger').click();
			}
		});
	}
});